<template>
    <ss-modal
            v-show="modal"
            title="Title"
            class="pay-schedules-modal"
            intro="bounceIn"
            outro ="bounceOut">
        <!-- HEADER -->
        <div slot = "modal-header" class="flex-header">
            <ul class="ss-tabs-nav">
                <li :class="{ active: activeTab === 0}"
                    @click="activeTab = 0"><span>Dodaj wpłaty do wielu</span></li>
                <li :class="{ active: activeTab === 1}"
                    @click="activeTab = 1"><span>Ostatnie wpłaty</span></li>
            </ul>
            <d-button @click.prevent="addPaymentRow" v-if="!sended">Dodaj nową</d-button>
        </div>
        <!-- BODY -->
        <div slot = "modal-body" class="text-center">
            <template v-if="activeTab === 0">
                <table class="table mb-0 responsive-table vam fixed-table" >
                    <thead class="bg-light">
                    <tr>
                        <th scope="col" class="border-0">Umowa</th>
                        <th scope="col" class="border-0">data wpłaty</th>
                        <th scope="col" class="border-0">Kwota wpłaty</th>
                        <th scope="col" class="border-0">Akcje</th>
                        <th scope="col" class="border-0">Status płatności</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                            v-for="(schedule, index) in schedules"
                            :key="'schedule-' + index">
                        <td>
                            <dt>Nr umowy</dt>
                            <dd>
                                <span class="text-success" v-if="schedule.status === 1">{{ schedule.contract_number ? schedule.contract_number : 'Brak nr umowy' }}</span>
                                <schedules-autocomplete @optionSelected="scheduleSelected(schedule, $event)" v-else></schedules-autocomplete>
                            </dd>
                        </td>
                        <td>
                            <dt>Data wpłaty</dt>
                            <dd>
                                <span class="text-success" v-if="schedule.status === 1">{{ schedule.paid_date }}</span>
                                <ss-date placeholder="Data wpłaty" v-model="schedule.paid_date" v-else></ss-date>
                            </dd>
                        </td>
                        <td>
                            <dt>Kwota wpłaty</dt>
                            <dd>
                                <span class="text-success" v-if="schedule.status === 1">{{ schedule.amount }} zł</span>
                                <ss-price-input v-model="schedule.amount"
                                                name="mortgage_amount"
                                                placeholder="Kwota (zł)"
                                                v-else></ss-price-input>
                            </dd>
                        </td>
                        <td>
                            <dt>Akcje</dt>
                            <dd>
                                <span v-if="schedule.status === 1">-</span>
                                <d-button @click.prevent="removeSchedule(schedule)" theme="danger" v-else>Usuń</d-button>
                                <d-button v-if="schedule.status === 0" class="ml-2" @click.prevent="paySchedule(schedule)" theme="primary" v-else>Opłać</d-button>
                            </dd>
                        </td>
                        <td>
                            <dt>Status płatności</dt>
                            <dd v-if="schedule.message" class="text-danger">{{ schedule.message }}</dd>
                            <dd v-else-if="schedule.status === 1"><i class="material-icons text-success bold font-weight-bolder">check</i></dd>
                            <dd v-else>-</dd>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p v-if="schedules.length < 1" class="text-info">Dodaj umowy do opłacenia.</p>
            </template>
            <template v-if="activeTab === 1">
                <div class="history-overflow-table">
                    <table class="table mb-0 responsive-table vam fixed-table" >
                        <thead class="bg-light">
                        <tr>
                            <th scope="col" class="border-0">Umowa</th>
                            <th scope="col" class="border-0">data wpłaty</th>
                            <th scope="col" class="border-0">Kwota wpłaty</th>
                            <th scope="col" class="border-0">Klient</th>
                            <th scope="col" class="border-0">Status umowy</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                                v-for="(payment, index) in payments_history"
                                :key="'payment-' + index">
                            <td>
                                <dt>Nr umowy</dt>
                                <dd>
                                    {{ payment.contract_number ? payment.contract_number : 'Brak nr umowy' }}
                                </dd>
                            </td>
                            <td>
                                <dt>Data wpłaty</dt>
                                <dd>
                                    {{ payment.paid_date }}
                                </dd>
                            </td>
                            <td>
                                <dt>Kwota wpłaty</dt>
                                <dd>
                                    {{ toNumber(payment.amount) }} zł
                                </dd>
                            </td>
                            <td>
                                <dt>Klient</dt>
                                <dd v-if="payment.client_name || payment.client_last_name">
                                    {{ payment.client_name  + ' ' + payment.client_last_name }}
                                </dd>
                                <dd v-else>
                                    {{ payment.company_name }}
                                </dd>
                            </td>
                            <td>
                                <dt>Status umowy</dt>
                                <dd>{{ lang[payment.payment_type] }}</dd>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <p v-if="payments_history.length < 1" class="text-info">Brak płatności do wyświetlenia.</p>
            </template>
        </div>
        <!-- FOOTER -->
        <div slot = "modal-footer">
            <d-button theme="success"  class="mr-3" v-if="!sended && activeTab === 0" :class="[{'isLoading': submitting }]" @click.prevent="submitPayments">Opłać</d-button>
            <d-button theme="danger" @click.prevent="modal = false" >Zamknij</d-button>
        </div>
    </ss-modal>
</template>

<script>
    import SsModal from '../common/SsModal'
    import SchedulesAutocomplete from '../common/SsSchedulesAutocomplete';
    import SsPriceInput from '../../components/common/SsPriceInput';
    import SsDate from '../../components/common/SsDate';

    export default {
        name: "PaySchedulesModal",
        components: {
            SsModal,
            SchedulesAutocomplete,
            SsPriceInput,
            SsDate
        },
        props: {
            props: {
                type: Object,
                default: ()=> {}
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                uid:            null,
                modal:          false,
                submitting:     false,
                sended:         false,
                activeTab:      0,
                payments_history: [],
                schedules:      [],
                lang: {
                    partial_payment: 'Częściowa',
                    entire_installment: "Cała rata",
                    contract_during: 'W trakcie trwania',
                    contract_terminated: 'Wypowiedziana',
                    contract_in_execution: 'W egzekucji'
                },
            }
        },
        mounted(){
            this.modal = this.show;
            this.fetchData();
            this.$eventHub.$on('refresh-schedules', this.fetchData);
            this.$eventHub.$on('show-pay-schedules-modal', ()=>{
                this.modal = true;
            });
        },
        //TODO search contracts 'api/schedules/search-contracts'
        methods: {
            fetchData(){
                axios.post('api/get-payment-history').then(response => {
                    this.payments_history = response.data.payment_history;
                }).catch((errors) => {
                })
            },
            toNumber(number){
              return Vue.toNumber(number);
            },
            addPaymentRow(){
              if(this.activeTab === 0){
                  this.schedules.push({
                      contract_number:  '',
                      id:               '',
                      amount:           0,
                      paid_date:        ''
                  })
              }
              else{
                  this.activeTab = 0;
                  if(this.schedules.length < 1){
                      this.schedules.push({
                          contract_number:  '',
                          id:               '',
                          amount:           0,
                          paid_date:        ''
                      })
                  }
              }

            },
            scheduleSelected(a, b){
                a.id = b.id;
                a.contract_number = b.contract_number;
            },
            removeSchedule(schedule){
                this.schedules.splice(this.schedules.indexOf(schedule), 1)
            },
            paySchedule(schedule){
                schedule.submitting = true;
                schedule.force = 1;
                axios.post('/api/schedules/mass-payments', [schedule]).then(response => {
                    this.schedules[this.schedules.indexOf(schedule)].status = response.data[0].status;
                    this.schedules[this.schedules.indexOf(schedule)].message = response.data[0].message;
                });
            },
            submitPayments(){
              if(this.schedules.length < 1){
                  Vue.swal({
                      type: 'error',
                     text: 'Dodaj płatności.'
                  });
                  return false;
              }
              if(this.schedules.reduce((sum, item) => {return item.id && item.paid_date && item.amount ? sum : sum+1}, 0) > 0){
                  Vue.swal({
                      type: 'error',
                      text: 'Uzupełnij pola wszystkich płatności.'
                  });
                  return false;
              }
                this.submitting = true;
                axios.post('/api/schedules/mass-payments', this.schedules).then(response => {
                    this.schedules = this.schedules.map(function(item, index) {
                        return {
                            ...item,
                            status: response.data[index].status,
                            message: response.data[index].message
                        };
                    });
                    this.submitting = false;
                    this.sended = true;
                    this.fetchData()
                });
            }
        },
        beforeDestroy () {
            this.$eventHub.$off('refresh-schedules');
            this.$eventHub.$off('show-pay-schedules-modal');
        },
        watch: {
            props: {
                handler: function(to) {
                    this.guarantor = to;
                },
                deep: true
            },
            show(to) {
                this.modal = to;
            },
            modal(to) {
                if(!to){
                    setTimeout(() => {
                        this.schedules = [];
                        this.sended = false;
                        this.submitting = false;
                    }, 500);
                }
                else{
                    this.fetchData();
                }
            }
        }
    }
</script>

<style lang="scss">

    .history-overflow-table{
        max-height: calc(100vh - 272px);
        overflow: auto;
    }
    .pay-schedules-modal{
        .modal-header{
            background-color: #F5F6F8;
        }
        .ss-tabs-nav{
            position: relative;
            top: 15px;
        }
        span.text-success{
            font-size: 16px;
        }
        .material-icons{
            font-size: 26px;
        }
        .modal-wrapper{
            align-items: flex-start;
        }
        .modal-body{
            margin: 0;
        }
        .modal-content{
            max-width: 980px;
        }
        .flex-header{
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
        }
        .fixed-table{
            table-layout: fixed;
        }
    }
</style>
